/* eslint-disable react/display-name */
import { clsx } from "clsx";
import React, { forwardRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { usePortalNode } from "../../../ui/hooks";

type HamburgerProps = {
  isOpen?: boolean;
  onClick: () => void;
};

export const Hamburger = forwardRef<HTMLButtonElement, HamburgerProps>(
  ({ isOpen = false, onClick, ...rest }, ref) => {
    const portalNode = usePortalNode();

    // NOTE: This is a workaround for the fact that the hamburger is rendered
    const [hamburgerState, setHamburgerState] = useState(isOpen);
    useEffect(() => {
      setHamburgerState(isOpen);
    }, [isOpen]);

    const hamburger = (
      <button
        {...rest}
        className={clsx(
          "flex flex-col items-center justify-center gap-y-1 h-16 w-16 md:h-20 md:w-20",
          hamburgerState && "fixed top-0 left-0 z-dialog-controls"
        )}
        aria-label="hamburder"
        onClick={onClick}
        ref={ref}
      >
        <div
          className={clsx(
            "h-0.5 bg-ink-2 rounded w-5 transition duration-500",
            hamburgerState && "scale-x-75 -rotate-[135deg] translate-y-1.5"
          )}
        />
        <div
          className={clsx(
            "h-0.5 bg-ink-2 rounded w-5 transition duration-500",
            hamburgerState && "scale-x-0"
          )}
        />
        <div
          className={clsx(
            "h-0.5 bg-ink-2 rounded w-5 transition duration-500",
            hamburgerState && "scale-x-75 rotate-[135deg] -translate-y-1.5"
          )}
        />
      </button>
    );
    return isOpen && portalNode
      ? createPortal(hamburger, portalNode)
      : hamburger;
  }
);
